export interface Video {
    id: string,
    name: string,
    description: string,
    linkURL?: string,
    linkText?: string,
    videoStillURL: string,
    thumbnailURL: string,
    length: string,
    createdDate: string,
    transcript: string
}

export enum VideoPlayerStatus {
    LOADING = 'LOADING',
    READY = 'READY',
    EMPTY = 'EMPTY',
    ERROR = 'ERROR'
}
